/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type UsersFindAllRole =
  (typeof UsersFindAllRole)[keyof typeof UsersFindAllRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersFindAllRole = {
  admin: 'admin',
  adminViewOnly: 'adminViewOnly',
  basic: 'basic',
  delegate: 'delegate',
  focalPoint: 'focalPoint',
  referenceCenter: 'referenceCenter',
  validated: 'validated',
} as const;
